// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__Hx9eu","secondary":"button_secondary__2urk-"};